import { useState , createContext , useContext } from 'react';

const ClientDetailsContext = createContext('');

const useClientDetailsContext = () => useContext(ClientDetailsContext);

const ClientDetailsProvider = ({ children }) => {
    const [ allClinicsData , setAllClinicsData ] = useState([]);
    const [ selectedClinicCode , setSelectedClinicCode ] = useState('');

    return <ClientDetailsContext.Provider value={{ selectedClinicCode , setSelectedClinicCode, allClinicsData , setAllClinicsData }}>{children}</ClientDetailsContext.Provider>
}

export {
    useClientDetailsContext,
    ClientDetailsProvider,
}